<template>
    <div>
        <!--components has been registered by: common/plugins/ComponentPlugin.js-->
        <NewsInfoModal></NewsInfoModal>
        <SearchBankVeritransModal></SearchBankVeritransModal>
        <ModalConfirm></ModalConfirm>
        <AgreementNewsModal></AgreementNewsModal>
        <CancelModal></CancelModal>
        <SearchBank></SearchBank>
        <SearchBranch></SearchBranch>
        <CryptoRegistrationCancelModal></CryptoRegistrationCancelModal>
        <BoRegistrationCancelModal></BoRegistrationCancelModal>
        <InformModal></InformModal>
        <CryptoAgeLimitModal></CryptoAgeLimitModal>
        <BoAgeLimitModal></BoAgeLimitModal>
        <TestDisabledModal></TestDisabledModal>
        <ServerErrorModal></ServerErrorModal>
        <UnsupportedBrowserModal></UnsupportedBrowserModal>
        <RegisterPasskeyResult/>
        <OtpMailChoosing/>
        <OtpInput/>
        <OtpInputResult/>
        <FidoAuthenticateUnsupported/>
        <ConfirmDeletePasskey/>
        <DeletePasskeyResult/>
        <RegisterPasskeyModal/>
        <RegisterPasskeyModalResult/>
    </div>
</template>

<script>
    export default {
        name: "ComposeModal",
    }
</script>